import React, {Suspense} from 'react';
import {useNative} from 'app/contexts/NativeContext';
const ATTComponent = React.lazy(() => import('app/components/lazyLoadWrapper/att/ATTComponent'));

const ATTLoader = () => {
  const {isNativeApp, platform} = useNative();
  const isIos = platform === 'ios';

  return isNativeApp && isIos ? (
    <Suspense fallback={null}>
      <ATTComponent />
    </Suspense>
  ) : null;
};

export default ATTLoader;
